"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ModalAssistant = exports.Modal = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Modal2 = _interopRequireDefault(require("../../Modal"));

var _icons = require("../../icons");

var _styles = require("../../../shared/styles");

var _selectors = require("../../../shared/styles/themes/selectors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 20px;\n  min-height: 60px;\n  min-width: 60px;\n  color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Modal = (0, _styledComponents["default"])(_Modal2["default"]).attrs(function (_ref) {
  var modalStyle = _ref.modalStyle,
      background = _ref.background,
      overlayColor = _ref.overlayColor,
      props = _objectWithoutProperties(_ref, ["modalStyle", "background", "overlayColor"]);

  return _objectSpread({
    modalStyle: {
      background: background || (0, _selectors.getField)('modalAssistant.backgroundColor', props)
    },
    modalWrapperStyle: {
      backgroundColor: overlayColor || (0, _selectors.getField)('modalAssistant.overlayColor', props)
    }
  }, modalStyle);
})(_templateObject(), function (props) {
  return (0, _selectors.getField)('modalAssistant.color', props);
});
exports.Modal = Modal;

var Body = _styledComponents["default"].div(_templateObject2(), function (props) {
  return (0, _selectors.getField)('modalAssistant.color', props);
});

var Footer = _styledComponents["default"].div(_templateObject3(), (0, _styles.margin)('m', 'top'), function (props) {
  return (0, _selectors.getField)('modalAssistant.color', props);
});

var Assistant = (0, _styledComponents["default"])(_icons.Assistant)(_templateObject4(), function (props) {
  return (0, _selectors.getField)('modalAssistant.assistantColor', props);
});

var ModalAssistant = function ModalAssistant(_ref2) {
  var children = _ref2.children,
      text = _ref2.text,
      footer = _ref2.footer,
      rest = _objectWithoutProperties(_ref2, ["children", "text", "footer"]);

  return /*#__PURE__*/_react["default"].createElement(Modal, rest, /*#__PURE__*/_react["default"].createElement(Body, {
    colorType: rest.colorType
  }, /*#__PURE__*/_react["default"].createElement(Assistant, {
    colorType: rest.colorType
  }), text), footer && /*#__PURE__*/_react["default"].createElement(Footer, {
    colorType: rest.colorType
  }, footer));
};

exports.ModalAssistant = ModalAssistant;
ModalAssistant.propTypes = {
  children: _propTypes["default"].node,
  text: _propTypes["default"].node,
  footer: _propTypes["default"].node,
  modalStyle: _propTypes["default"].object
};
var _default = ModalAssistant;
exports["default"] = _default;